import { render, staticRenderFns } from "./QScoreText.vue?vue&type=template&id=0423e20e&scoped=true"
import script from "./QScoreText.vue?vue&type=script&lang=js"
export * from "./QScoreText.vue?vue&type=script&lang=js"
import style0 from "./QScoreText.vue?vue&type=style&index=0&id=0423e20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423e20e",
  null
  
)

export default component.exports